import Breadcrumb from "components/Common/Breadcrumb"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { FaEdit, FaEye, FaPen } from "react-icons/fa"
import {
  Button,
  Card,
  CardBody,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { BsThreeDotsVertical } from "react-icons/bs"
import { MdPerson } from "react-icons/md"
import UnavailabilityModal from "./Unavaliablity"
import { fetchData, FetchPostData } from "utils/Common_api_functions"
import Loader from "components/Loader/loader"
import Swal from "sweetalert2"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"

const calculateTotalHours = (start, end) => {
  if (!start || !end) return ""

  let startDate, endDate

  // If start is a DATE OBJECT (calendar)
  if (start instanceof Date) {
    startDate = new Date(start)
  }
  // If start is a TIME STRING (modal)
  else if (typeof start === "string") {
    const [h, m] = start.split(":")
    startDate = new Date()
    startDate.setHours(h)
    startDate.setMinutes(m)
  }

  // Same logic for end
  if (end instanceof Date) {
    endDate = new Date(end)
  } else if (typeof end === "string") {
    const [h, m] = end.split(":")
    endDate = new Date()
    endDate.setHours(h)
    endDate.setMinutes(m)
  }

  // If end time is next day
  if (endDate < startDate) {
    endDate.setDate(endDate.getDate() + 1)
  }

  const diffMs = endDate - startDate
  const diffHrs = Math.floor(diffMs / (1000 * 60 * 60))
  const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))

  return `${diffHrs}h ${diffMins}m`
}

const Calender = () => {
  document.title = "Dashboard | J. Kyle Cleaning Services"

  const [loading, setLoading] = useState(false)

  const [services, setServices] = useState([])

  const [selectedLocation, setSelectedLocation] = useState("")
  const [selectedEmployee, setSelectedEmployee] = useState("")
  const [locationTypeFilter, setLocationTypeFilter] = useState("")

  const [dropdownOpen, setDropdownOpen] = useState({})

  const [releatedEmployees, setRelatedEmployees] = useState([])

  // Modal states
  const [leaveModal, setLeaveModal] = useState(false)
  const [jobModal, setJobModal] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState(null)

  console.log(selectedEvent)

  const [unavaliblityModal, setUnavaliblityModal] = useState(false)

  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(today.getDate() + 1)
  const dayAfter = new Date(today)
  dayAfter.setDate(today.getDate() + 2)

  const [events, setEvents] = useState([])

  const filteredEvents = events.filter(event => {
    /* 📍 Location filter */
    const matchLocation =
      !selectedLocation ||
      String(event.locationId ?? event.location?.id) ===
        String(selectedLocation)

    /* 👤 Employee filter */
    const matchEmployee =
      !selectedEmployee ||
      event.employees?.some(
        emp => String(emp.employeeId) === String(selectedEmployee)
      )

    /* 🏷️ TYPE filter (same logic as earlier) */
    const matchType =
      !locationTypeFilter?.length ||
      // check location type
      JSON.parse(event.location?.type)?.some(t =>
        locationTypeFilter.includes(t)
      ) ||
      // OR check employee type
      event.employees?.some(
        emp =>
          (locationTypeFilter.includes("window_cleaning") &&
            emp.isWindowCleaner) ||
          (locationTypeFilter.includes("industrial_cleaning") &&
            emp.isIndustrialCleaner)
      )

    return matchLocation && matchEmployee && matchType
  })

  useEffect(() => {
    getCalenderData()
  }, [])

  async function getCalenderData() {
    const APIData = await fetchData(setLoading, "calendar")
    if (APIData?.success) {
      const rawData = APIData.data.map(item => ({
        ...item,
        start: moment(
          `${item.date} ${item.inTime}`,
          "YYYY-MM-DD HH:mm"
        ).toDate(),
        end: moment(
          `${item.date} ${item.outTime}`,
          "YYYY-MM-DD HH:mm"
        ).toDate(),
      }))

      const grouped = Object.values(
        rawData.reduce((acc, item) => {
          const key = `${item.locationSlotId}-${item.date}`
          // 👆 Combines slot + date into a unique group

          if (!acc[key]) {
            acc[key] = {
              ...item,
              employees: [item],
            }
          } else {
            acc[key].employees.push(item)
          }

          return acc
        }, {})
      )

      // 🔹 Give each event a title
      const formattedData = grouped.map(g => ({
        ...g,
        title: `${g.location?.name || "Location"} (${
          g.employees.length
        } Employees)`,
      }))

      setEvents(formattedData)
    }

    const APIdata2 = await fetchData(setLoading, "services")
    if (APIdata2?.success) {
      setServices(APIdata2.data)
    }
  }

  async function getLocationEmployees(day, inTime, outTime, locationId) {
    const APIdata = await FetchPostData(
      setLoading,
      `slot/available/employees`,
      {
        day,
        inTime,
        outTime,
        locationId,
      }
    )
    if (APIdata?.data?.success) {
      setRelatedEmployees(APIdata?.data?.employees)
    }
  }

  const toggleLeaveModal = () => {
    setLeaveModal(!leaveModal)
  }
  const toggleJobModal = () => setJobModal(!jobModal)

  const handleLeaveModal = event => {
    setSelectedEvent(event)
    const date = event?.employees?.[0]?.date
    const dayNumber = moment(date, "YYYY-MM-DD").day()
    getLocationEmployees(
      dayNumber,
      event?.inTime,
      event?.outTime,
      event?.location?.id
    )
    setLeaveModal(true)
  }

  const handleJobModal = event => {
    setSelectedEvent(event)
    setJobModal(true)
  }

  const handleUnavaliblity = event => {
    setSelectedEvent(event)
    setUnavaliblityModal(true)
  }

  const toggleDropdown = eventId => {
    setDropdownOpen(prev => ({
      ...prev,
      [eventId]: !prev[eventId],
    }))
  }

  const EventComponent = info => {
    const event = info.event.extendedProps // 🔑 IMPORTANT
    const eventId = info.event.id
    const formatTime = date =>
      new Date(date).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
    return (
      <div
        className=" mt-1 w-100 rounded-3  p-2"
        style={{ backgroundColor: "#3174ad" }}
        onClick={e => e.stopPropagation()} // ⛔ prevent calendar click
      >
        {/* TIME */}
        <p
          className="text-white text-start fw-bold mb-1"
          style={{ fontSize: "11px" }}
        >
          {formatTime(info.event.start)} - {formatTime(info.event.end)}
        </p>

        <div className="d-flex align-items-center justify-content-between">
          {/* LOCATION INITIALS */}
          <h6
            className=" fw-bold bg-warning rounded-circle header-profile-initials d-flex align-items-center justify-content-center"
            style={{ fontSize: "12px", width: 26, height: 26 }}
          >
            {String(event?.location?.name || "")
              .split(" ")
              .slice(0, 3)
              .map((el, idx) => (
                <span key={idx} className="text-dark">
                  {el[0]}
                </span>
              ))}
          </h6>

          {/* EMPLOYEES */}
          <div className="d-flex align-items-center mb-1">
            {event?.employees
              ?.filter(item => item?.replaced !== true)
              .map((el, idx) => (
                <h6
                  key={idx}
                  className="my-1 me-1 fw-bold rounded-circle header-profile-initials d-flex align-items-center justify-content-center"
                  style={{
                    fontSize: "12px",
                    backgroundColor:
                      el?.status === "On Holiday"
                        ? "rgb(215, 69, 69)"
                        : el.status === "Unavailable"
                        ? "#aaa"
                        : "#fff",
                    color:
                      el?.status === "On Holiday" ||
                      el?.status === "Unavailable"
                        ? "#fff"
                        : "#000",
                  }}
                >
                  {String(el?.employee?.name || "")
                    .split(" ")
                    .slice(0, 2)
                    .map((name, i) => (
                      <span key={i}>{name[0]}</span>
                    ))}
                </h6>
              ))}

            {/* DROPDOWN */}
            <Dropdown
              isOpen={dropdownOpen[eventId]}
              toggle={e => {
                e.stopPropagation()
                toggleDropdown(eventId)
              }}
            >
              <DropdownToggle
                tag="button"
                className="btn btn-sm btn-link p-0 text-white"
                onClick={e => e.stopPropagation()}
              >
                <BsThreeDotsVertical size={18} />
              </DropdownToggle>

              <DropdownMenu
                end
                style={{
                  zIndex: 99999, // Increase z-index
                  position: "absolute", // ensure absolute positioning
                }}
              >
                <DropdownItem
                  onClick={e => {
                    e.stopPropagation()
                    handleLeaveModal(event)
                  }}
                >
                  <FaPen className="me-2" size={12} />
                  Edit
                </DropdownItem>

                <DropdownItem
                  onClick={e => {
                    e.stopPropagation()
                    handleJobModal(event)
                  }}
                >
                  <FaEye className="me-2" size={12} />
                  View
                </DropdownItem>

                <DropdownItem
                  onClick={e => {
                    e.stopPropagation()
                    handleUnavaliblity(event)
                  }}
                >
                  <MdPerson className="me-2" size={12} />
                  Unavailability
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      </div>
    )
  }

  const uniqueLocations = [
    ...new Map(
      filteredEvents
        ?.filter(e => e?.location?.id) // 🚫 remove null/undefined employees
        .map(e => [e?.location?.id, e?.location])
    ).values(),
  ]

  const uniqueEmployees = [
    ...new Map(
      filteredEvents
        ?.filter(e => e?.employee?.id) // 🚫 remove null/undefined employees
        .map(e => [e.employee.id, e.employee])
    ).values(),
  ]

  const [editedRows, setEditedRows] = useState({})

  const handleUpdateEmployee = async (index, eventId) => {
    const rowData = editedRows[index]

    if (!rowData) {
      Swal.fire("No changes", "Please edit employee or price first", "info")
      return
    }

    // 🔥 Confirmation popup
    const confirm = await Swal.fire({
      title: "Confirm Update?",
      text: "Are you sure you want to update this employee's details?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, update",
      cancelButtonText: "Cancel",
    })

    if (!confirm.isConfirmed) return // user cancelled

    const payload = {
      employeeId: rowData.employeeId,
      newHourlyRate: rowData.price,
      calendarSlotId: eventId,
      replaced: true,
      replacedBy: rowData?.employeeId,
    }

    const result = await FetchPostData(
      setLoading,
      "calendar/assign/proxy/employee",
      payload
    )

    if (result?.data?.success) {
      Swal.fire("Updated!", "Employee updated successfully", "success")
      getCalenderData()
      toggleLeaveModal()
    } else {
      Swal.fire(
        "Error",
        result?.response?.data?.message || "Failed to update",
        "error"
      )
    }
  }

  const { checkAccess } = usePermissionData()

  return (
    <div className="page-content">
      {loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(1, 1) || checkAccess(1, 2)}>
        <Container fluid>
          <Breadcrumb
            title={"Dashboards"}
            breadcrumbItem={"Calendar"}
            description={"View and Update Employees and Emp Payment"}
          />
          <Card className="shadow-lg">
            <CardBody className="cal-job">
              <div className="d-flex justify-content-between mb-3">
                <h4>Employee Location Calendar</h4>
                <div className="d-flex gap-3">
                  <select
                    className="form-select rounded-4 ps-3 pe-5 w-auto"
                    value={locationTypeFilter}
                    onChange={e => {
                      setLocationTypeFilter(e.target.value)
                    }}
                  >
                    <option value="">All (Both Type)</option>
                    <option value="window_cleaning">Window Cleaning</option>
                    <option value="industrial_cleaning">
                      Industrial Cleaning
                    </option>
                  </select>
                  <select
                    className="form-select w-auto rounded-4"
                    value={selectedLocation}
                    onChange={e => setSelectedLocation(e.target.value)}
                  >
                    <option value="">Select Location</option>
                    {uniqueLocations
                      ?.filter(i => i?.id)
                      .map(loc => (
                        <option key={loc?.id} value={loc?.id}>
                          {loc?.name}
                        </option>
                      ))}
                  </select>
                  <select
                    className="form-select w-auto rounded-4"
                    value={selectedEmployee}
                    onChange={e => setSelectedEmployee(e.target.value)}
                  >
                    <option value="">Select Employee</option>
                    {uniqueEmployees
                      ?.filter(i => i.id)
                      .map(emp => (
                        <option key={emp.id} value={emp.id}>
                          {emp.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <FullCalendar
                plugins={[dayGridPlugin, timeGridPlugin]}
                initialView="dayGridWeek"
                events={filteredEvents}
                eventContent={EventComponent}
                dayHeaderContent={args => {
                  const date = args.date
                  const d = String(date.getDate()).padStart(2, "0")
                  const m = String(date.getMonth() + 1).padStart(2, "0")
                  const y = date.getFullYear()
                  const weekday = date.toLocaleDateString("en-GB", {
                    weekday: "short",
                  })
                  return `${weekday} ${d}-${m}-${y}`
                }}
                headerToolbar={{
                  left: "prev,next today",
                  right: "title",
                }}
                views={{
                  timeGridWeek: { buttonText: "Week" },
                  timeGridDay: { buttonText: "Day" },
                  dayGridMonth: { buttonText: "Month" },
                }}
                className="Attendance-Calender"
              />
            </CardBody>
          </Card>

          {/* Leave Modal */}
          <Modal
            isOpen={leaveModal}
            toggle={toggleLeaveModal}
            centered
            size="lg"
          >
            <ModalHeader
              toggle={toggleLeaveModal}
              className="fw-bold text-primary"
            >
              Assign Proxy Employee
            </ModalHeader>

            <ModalBody>
              <h5 className="fw-bold text-primary mb-3">Job Information</h5>
              <Table
                bordered
                responsive
                hover
                className="align-middle border-dark shadow-sm rounded"
              >
                <tbody>
                  <tr>
                    <td>Location</td>
                    <td>{selectedEvent?.location?.name}</td>
                  </tr>

                  <tr>
                    <td>Service</td>
                    <td>
                      {(() => {
                        let serviceIds = selectedEvent?.location?.services

                        // If service is a string like "[1,2,4]" then parse
                        if (typeof serviceIds === "string") {
                          try {
                            serviceIds = JSON.parse(serviceIds)
                          } catch (e) {
                            console.log("JSON parse error:", e)
                            serviceIds = []
                          }
                        }

                        return services
                          ?.filter(s => serviceIds?.includes(s.id))
                          ?.map(s => s.name)
                          ?.join(" , ")
                      })()}
                    </td>
                  </tr>

                  <tr>
                    <td>On Holiday Employees</td>
                    <td>
                      {selectedEvent?.employees
                        ?.filter(item => item?.replaced === true)
                        ?.map(emp => emp?.employee?.name)
                        ?.join(", ")}
                    </td>
                  </tr>
                </tbody>
              </Table>

              <h5 className="fw-bold text-primary my-3">Assigned Employee</h5>

              <div
                style={{
                  maxHeight: "200px",
                  overflowX: "hidden",
                  overflowY: "auto",
                  scrollbarWidth: "thin",
                }}
              >
                {/* Repeat employee rows */}
                {selectedEvent?.employees
                  ?.filter(item => item?.replaced !== true)
                  ?.map((row, index) => (
                    <Row key={row} className="align-items-center">
                      <FormGroup className="col-5 mb-0">
                        <Label className="fw-semibold">Select Employee</Label>
                        <select
                          className="rounded-4 form-select shadow-sm"
                          value={editedRows[index]?.employeeId || row?.id}
                          onChange={e =>
                            setEditedRows(prev => ({
                              ...prev,
                              [index]: {
                                ...prev[index],
                                employeeId: e.target.value,
                              },
                            }))
                          }
                          disabled={row?.status === "Available"}
                        >
                          {selectedEvent?.employees.map(emp => (
                            <option key={emp?.id} value={emp?.id}>
                              {emp?.employee?.name}
                            </option>
                          ))}
                          {releatedEmployees?.map(emp => (
                            <option key={emp?.id} value={emp?.id}>
                              {emp.name}
                            </option>
                          ))}
                        </select>
                        <p className="mt-1 mb-0">
                          Note :{" "}
                          <span className="fw-bold text-danger">
                            Employee is {row?.status}{" "}
                          </span>
                        </p>
                      </FormGroup>

                      <FormGroup className="col-5">
                        <Label className="fw-semibold">
                          Employee Base Price
                        </Label>
                        <Input
                          type="number"
                          className="rounded-3 shadow-sm"
                          placeholder="Enter price for this job/day"
                          value={
                            editedRows[index]?.price ||
                            row?.newHourlyRate ||
                            selectedEvent?.location?.employeePrice
                          }
                          onChange={e =>
                            setEditedRows(prev => ({
                              ...prev,
                              [index]: {
                                ...prev[index],
                                price: e.target.value,
                              },
                            }))
                          }
                        />

                        <p className="mt-1 mb-0">
                          <span className="fw-bold">Note : </span>(Location
                          Price : £ {selectedEvent?.location?.employeePrice})
                        </p>
                      </FormGroup>

                      <Button
                        className="col-2 mb-2"
                        onClick={() =>
                          handleUpdateEmployee(index, selectedEvent?.id)
                        }
                      >
                        <FaEdit /> Update
                      </Button>
                    </Row>
                  ))}
              </div>
            </ModalBody>
          </Modal>

          {/* Job Details Modal */}
          <Modal isOpen={jobModal} toggle={toggleJobModal} centered size="lg">
            <ModalHeader toggle={toggleJobModal} className="fw-bold text-info">
              Job Details
            </ModalHeader>
            <ModalBody>
              {selectedEvent && (
                <>
                  {/* Main Job Details */}
                  <h5 className="fw-bold text-primary mb-3">Job Information</h5>
                  <Table
                    bordered
                    responsive
                    hover
                    className="align-middle border-dark shadow-sm rounded"
                  >
                    <tbody>
                      <tr>
                        <th>Location</th>
                        <td>{selectedEvent.location?.name}</td>
                      </tr>
                      <tr>
                        <th className="bg-light">Service</th>
                        <td>
                          {(() => {
                            let serviceIds = selectedEvent?.location?.services

                            // If service is a string like "[1,2,4]" then parse
                            if (typeof serviceIds === "string") {
                              try {
                                serviceIds = JSON.parse(serviceIds)
                              } catch (e) {
                                console.log("JSON parse error:", e)
                                serviceIds = []
                              }
                            }

                            return services
                              ?.filter(s => serviceIds?.includes(s.id))
                              ?.map(s => s.name)
                              ?.join(" , ")
                          })()}
                        </td>
                      </tr>
                      <tr>
                        <th className="bg-light">Employees</th>
                        <td>
                          {selectedEvent?.employees
                            ?.map(emp => emp?.employee?.name)
                            .join(", ")}
                        </td>
                      </tr>
                      <tr>
                        <th className="bg-light">Total Job Time</th>
                        <td>
                          {calculateTotalHours(
                            selectedEvent?.inTime,
                            selectedEvent?.outTime
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>

                  {/* Employee Entries */}
                  <h5 className="fw-bold text-success mt-4 mb-3">
                    Employee Entries
                  </h5>
                  <Table
                    bordered
                    responsive
                    hover
                    className="align-middle border-secondary shadow-sm rounded"
                  >
                    <thead className="bg-blue">
                      <tr>
                        <th>Employee Name</th>
                        <th>Service</th>
                        <th>Start</th>
                        <th>End</th>
                        <th>Total Hours</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Static example data */}
                      {selectedEvent?.employees?.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.employee?.name}</td>
                          <td style={{ width: "40%" }}>
                            {(() => {
                              let serviceIds = selectedEvent?.location?.services

                              // If service is a string like "[1,2,4]" then parse
                              if (typeof serviceIds === "string") {
                                try {
                                  serviceIds = JSON.parse(serviceIds)
                                } catch (e) {
                                  console.log("JSON parse error:", e)
                                  serviceIds = []
                                }
                              }

                              return services
                                ?.filter(s => serviceIds?.includes(s.id))
                                ?.map(s => s.name)
                                ?.join(" , ")
                            })()}
                          </td>
                          <td>
                            {selectedEvent?.inTime
                              ? moment(selectedEvent.inTime, "HH:mm").format(
                                  "hh:mm A"
                                )
                              : "—"}
                          </td>
                          <td>
                            {selectedEvent?.outTime
                              ? moment(selectedEvent.outTime, "HH:mm").format(
                                  "hh:mm A"
                                )
                              : "—"}
                          </td>
                          <td>
                            {calculateTotalHours(
                              selectedEvent?.inTime,
                              selectedEvent?.outTime
                            )}
                          </td>
                          <td className="fw-bold">
                            <span
                              className={`badge px-3 py-2 ${
                                item?.status === "Available"
                                  ? "bg-success"
                                  : item?.status === "On Holiday"
                                  ? "bg-danger"
                                  : item?.status === "Leave Rejected"
                                  ? "bg-warning text-dark"
                                  : "bg-secondary"
                              }`}
                            >
                              {item?.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </ModalBody>
          </Modal>

          <UnavailabilityModal
            unavaliblityModal={unavaliblityModal}
            setUnavaliblityModal={setUnavaliblityModal}
            selectedEvent={selectedEvent}
            getData={getCalenderData}
          />
        </Container>
      </PermittedComponent>
    </div>
  )
}

export default Calender
